export default {
  ISRAEL_SALES_PHONE_LINK: "tel:97237370076",
  ISRAEL_SALES_PHONE_DISPLAY_TEXT: "+972 3 737 0076",
  UK_SALES_PHONE_LINK: "tel:442039668735",
  UK_SALES_PHONE_DISPLAY_TEXT: "+44 20 3966 8735",
  AUSTRALIA_SALES_PHONE_LINK: "tel:61279083292",
  AUSTRALIA_SALES_PHONE_DISPLAY_TEXT: "+61 2 7908 3292"
};
